export default class ComponenteTextLabelOptions {
  constructor({
    solicitanteNome = '',
    enderecoFormatado = '',
    empresaNome = '',
  } = {}) {
    this.solicitanteNome = solicitanteNome
    this.enderecoFormatado = enderecoFormatado
    this.empresaNome = empresaNome
  }
}
